import { CommunicationsWorkspace } from '@features/communications/components/CommunicationsWorkspace'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/communication/')({
    component: CommunicationsWorkspace,
    staticData: {
        crumb: {
            label: 'Communications',
        },
    },
})
